/**
 * Procedural WebAudio stubs — original beeps, not ripped game audio.
 */
export class AudioStubs {
  constructor() {
    this.ctx = null;
    this.enabled = true;
  }

  ensure() {
    if (!this.ctx) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (AC) this.ctx = new AC();
    }
    if (this.ctx?.state === 'suspended') this.ctx.resume();
  }

  tone(freq, dur = 0.08, type = 'square', gain = 0.04) {
    if (!this.enabled) return;
    this.ensure();
    if (!this.ctx) return;
    const t0 = this.ctx.currentTime;
    const o = this.ctx.createOscillator();
    const g = this.ctx.createGain();
    o.type = type;
    o.frequency.value = freq;
    g.gain.setValueAtTime(gain, t0);
    g.gain.exponentialRampToValueAtTime(0.001, t0 + dur);
    o.connect(g);
    g.connect(this.ctx.destination);
    o.start(t0);
    o.stop(t0 + dur);
  }

  coin() { this.tone(880, 0.06, 'triangle', 0.05); this.tone(1320, 0.08, 'triangle', 0.03); }
  jump() { this.tone(220, 0.1, 'sawtooth', 0.03); }
  roll() { this.tone(140, 0.12, 'triangle', 0.035); }
  lane() { this.tone(320, 0.05, 'square', 0.025); }
  power() { this.tone(520, 0.1, 'sine', 0.05); this.tone(780, 0.15, 'sine', 0.04); }
  hit() { this.tone(90, 0.25, 'sawtooth', 0.06); }
  revive() { this.tone(440, 0.12, 'sine', 0.05); this.tone(660, 0.18, 'sine', 0.04); }
}
